<script setup lang="ts">
import type { Color } from '../../types/shared'
import type { IconsKeys } from './types'

import { SPRITE_VERSION } from './Icon.version'

type IconColorProperty = '--fillColor' | '--strokeColor'

type Props = {
  name: IconsKeys
  size?: number | string
  color?: Color
  clickable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: '',
})

const sizeStyle = computed(() => {
  return {
    width: `${props.size}px`,
    height: `${props.size}px`,
  }
})

const svgStyles = computed(() => {
  const styles: Partial<Record<IconColorProperty, string>> = {}

  if (props.color) {
    styles['--fillColor'] = props.color
    styles['--strokeColor'] = props.color
  }

  return styles
})

const iconPath = computed(() => {
  return `/sprites.svg?v=${SPRITE_VERSION}#${props.name}`
})
</script>

<template>
  <svg
    class="app-icon"
    :class="{ 'app-icon--clickable': clickable }"
    :style="{ ...svgStyles, ...sizeStyle }"
    v-bind="$attrs"
  >
    <use :xlink:href="iconPath" />
  </svg>
</template>

<style scoped lang="scss">
@use '../../assets/ui-layer/styles/mixins' as *;

.app-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  fill: var(--fillColor, #2b211f);
  stroke: var(--strokeColor, #2b211f);
  transition: fill 0.3s ease, stroke 0.3s ease;

  &--clickable {
    @include media('>=desktop-mini') {
      cursor: pointer;
    }
  }
}
</style>
